import { SvgIcon, SvgIconProps } from "@mui/material";

export default function ReturnIcon(props: Readonly<SvgIconProps>) {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <path
        d="M6.37109 8.79883C6.43555 8.64844 6.58594 8.58398 6.73633 8.60547L12 9.25L17.2422 8.60547C17.3926 8.58398 17.543 8.66992 17.6074 8.79883L18.4883 10.582C18.6816 10.9688 18.4883 11.4414 18.0801 11.5488L14.5566 12.5586C14.2559 12.6445 13.9336 12.5156 13.7832 12.2363L12 9.25L10.1953 12.2363C10.0449 12.5156 9.72266 12.6445 9.42188 12.5586L5.91992 11.5488C5.49023 11.4414 5.29688 10.9688 5.49023 10.582L6.37109 8.79883ZM12.0215 10.625L13.2031 12.6016C13.5039 13.1387 14.1484 13.375 14.75 13.2031L17.5 12.4297V16.0176C17.5 16.4902 17.1777 16.8984 16.7051 17.0273L12.3223 18.123C12.1074 18.166 11.8711 18.166 11.6562 18.123L7.27344 17.0273C6.82227 16.8984 6.5 16.4902 6.5 16.0176V12.4297L9.22852 13.2031C9.83008 13.375 10.4746 13.1387 10.7969 12.6016L11.957 10.625H12.0215Z"
        fill="currentColor"
      />
      <path
        d="M12 3.00098C17.5001 3.0278 21.9511 7.49376 21.9512 13L21.9375 13.5146C21.6697 18.7984 17.3006 23 11.9502 23C6.76484 22.9999 2.50175 19.0532 2 14H4.01465C4.50689 17.9461 7.87063 20.9999 11.9502 21C16.3687 21 19.9512 17.4183 19.9512 13C19.9511 8.59837 16.3955 5.02777 12 5.00098V7L9 4L12 1V3.00098Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}

